import React from 'react';
import { CampaignForm } from './CampaignForm';
import { CampaignProvider } from './CampaignContext';

export const CampaignPage: React.FC = () => (
  <CampaignProvider>
    <CampaignForm />
  </CampaignProvider>
);
